
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Member } from '../types/memberTypes';
import MemberPermissionsTooltip from '../MemberPermissionsTooltip';
import { permissionOptions } from '../types/memberTypes';

interface MemberMobileViewModeProps {
  member: Member;
  getCheckedPermissionsCount: (permissions?: any[]) => number;
  getCheckedPermissionNames: (permissions?: any[]) => string[];
}

const MemberMobileViewMode: React.FC<MemberMobileViewModeProps> = ({
  member,
  getCheckedPermissionsCount,
  getCheckedPermissionNames
}) => {
  // For owners and primary owners, ensure all permissions are checked, except viewOnly
  const displayRole = member.role;
  let displayPermissions = member.permissions || [];
  
  if (displayRole === 'Owner' || displayRole === 'Primary Owner') {
    displayPermissions = permissionOptions
      .filter(option => option.id !== 'viewOnly')
      .map(option => ({
        id: option.id,
        name: option.name,
        checked: true
      }));
  }
  
  return (
    <div className="space-y-3">
      <div>
        <p className="text-sm font-medium">Role</p>
        <Badge 
          variant={member.role === 'Primary Owner' ? 'default' : member.role === 'Owner' ? 'secondary' : 'outline'}
          className={member.role === 'Manager' ? 'bg-gray-100 text-gray-800 hover:bg-gray-200' : ''}
        >
          {member.role}
        </Badge>
      </div>
      
      <div>
        <p className="text-sm font-medium">Permissions</p>
        <MemberPermissionsTooltip
          permissions={displayPermissions}
          getCheckedPermissionsCount={getCheckedPermissionsCount}
          getCheckedPermissionNames={getCheckedPermissionNames}
        >
          <div className="mt-1 cursor-help">
            <span className="text-sm">{getCheckedPermissionsCount(displayPermissions)} permissions</span>
          </div>
        </MemberPermissionsTooltip>
      </div>
      
      {/* Add status for invited members */}
      {member.status === 'invited' && !member.isCurrentUser && (
        <div>
          <p className="text-sm font-medium">Status</p>
          <Badge variant="outline" className="bg-amber-50 text-amber-600 border-amber-200">
            Pending Invitation
          </Badge>
        </div>
      )}
    </div>
  );
};

export default MemberMobileViewMode;
